<div class="page_header mt-20">
    <h6 class="heading">Account Number :{{carrierAccNumber}}| Account Name :{{carrierNames}} |Carrier
        Type:{{carrierType}}</h6>
</div>


<div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
</div>

<!--header section-->
<div class="inline-container mt-lg-2">
    <div class="top-center-container">
        <strong><h5 class="headertitle">Monthly Returns - {{permitHeadingType}}</h5></strong>
        <p class="username">{{ user?.UserName }}</p>
    </div>
    <div class="ml-lg-3">
        |
    </div>

    <div class="ml-lg-5 top-center-container">

            <select [(ngModel)]="ComplianceReturnId" class="form-select input-gray-border" (change)="changePermits()">
                <option *ngFor="let perm of allPermitReturns" [value]="perm.id" > {{perm?.calendar?.mmm}} - {{perm?.calendar?.yyyy}}</option>
            </select>
    </div>
    <div class="ml-lg-3">
        |
    </div>
    <div class="ml-lg-5 top-center-container">
        <div class="form-check">
            <input class="form-check-input"   [(ngModel)]="isNoTrip" type="checkbox" value="" id="nullTrips"
                   (change)="SetNoTrip()">
            <label class="form-check-label btn-bold-title" for="nullTrips">
                No trips for this month
            </label>
        </div>
    </div>

    <div class="ml-lg-5 right-container">
        <button class="btn btn-import button" style="display: none">
            <div class="btn-bold-title">Import</div>
        </button>
        <button class="btn btn-previous button" style="display: none">
            <div class="btn-bold-title">Previous Permit</div>
        </button>
        <button class="btn btn-next button" style="display: none">
            <div class="btn-bold-title">Next Permit</div>
        </button>
    </div>
</div>
<!--end of header section-->
<br/>
<br/>
<!--driver section-->
<!--driver section-->
<div class="inline-container mt-lg-2">
    <h5 class="opensans-semi-bold-black-16px">Permit Number: </h5>
    <h5 class="opensans-semi-bold-sapphire-16px ml-2"> {{permitDetails?.permit_num}}</h5>

    <h5 class="opensans-semi-bold-black-16px ml-5">Permit Type: </h5>
    <h5 class="opensans-semi-bold-sapphire-16px ml-2"> {{isLongShort}}</h5>

    <h5 class="opensans-semi-bold-black-16px ml-5">Expiry Date: </h5>
    <h5 class="opensans-semi-bold-sapphire-16px ml-2"> {{permitExpiryDate}}</h5>

</div>
<br/>
<br/>
<!--<div class="background-polo m-3 p-5">-->


    <!--    <table width="80%" >-->
    <!--        <tbody>-->
    <!--        <tr class="m-2 p-2" *ngFor="let driver of drivers; let i = index">-->
    <!--            <td class="driver-name bold-text m-2">{{ driver.name }}-->
    <!--                <br/></td>-->
    <!--            <td class="m-5"><input type="checkbox" [(ngModel)]="driver.checked">-->
    <!--                <br/></td>-->
    <!--            <td class="m-5">-->

    <!--                <select class="long-select" [(ngModel)]="driver.dropdown">-->
    <!--                    <option value="Option 1">Option 1</option>-->
    <!--                    <option value="Option 2">Option 2</option>-->
    <!--                    <option value="Option 3">Option 3</option>-->
    <!--                </select>-->
    <!--                <br/>-->
    <!--            </td>-->
    <!--        </tr>-->
    <!--        </tbody>-->
    <!--    </table>-->
<!--</div>-->

<!--<button (click)="addDriver()">Add Driver</button>-->
<!--end of driver-->

<!--forward or return button section-->
<div class="ml-lg-5">

    <button [ngClass]="{'btn-next' : isFowards, 'btn-return-tab' : !isFowards}"   class="btn  button-tabs"
            (click)="showForwardReturn('Forward')">
        <div class="btn-bold-title">Forward Trips</div>
    </button>

    <button [ngClass]="{'btn-next' : !isFowards, 'btn-return-tab' : isFowards}"   class="btn  button-tabs"
            (click)="showForwardReturn('Return')">
        <div class="btn-bold-title">Return Trips</div>
    </button>

</div>
<!--end of forward or return button section-->
<div class="pull-right" *ngIf="!isNoTrip">
    <button class="btn btn-next button-tabs"   (click)="RegisterDriver()">
        <div class="btn-bold-title">Add A Driver</div>
    </button>
</div>
<br/>
<br/>
<!--TO DO: Create a common component for both forward and return: a work for another day.-->
<!--Forward Trips Table-->
<!--<div class="mt-lg-5" *ngIf="isFowards">-->
<div class="mt-lg-5" [ngStyle]="{'display' : isFowards ? 'block' : 'none'}">
    <table class="table custom_table" cellspacing="0" width="100%">
        <thead>
        <tr>
            <th>Day & Date</th>
            <th class="th-sm">
                Trip?
            </th>
            <th class="th-sm">
                Copy Previous
            </th>
            <th class="th-sm">
                Registration No
            </th>
            <th>
                Driver
            </th>
            <th>
                Depart From
            </th>
            <th>
                SA Border
            </th>
            <th>
                Last Border
            </th>
            <th>
                Destination
            </th>
            <th *ngIf="isPassenger">
                Number of passengers
            </th>
            <th *ngIf="!isPassenger">
                Freight Category
            </th>
            <th *ngIf="!isPassenger">
                Mass
            </th>
            <th>
                # Docs
            </th>
            
            <th class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of monthlyFowardsReturns.slice(getStartIndex(), getEndIndex()); let i = index">
            <td><label>{{item.calendar.ddd}}, {{item.calendar.dd}} {{item.calendar.mmm}}  </label></td>
            <td><input class="form-check-input"   type="checkbox" [(ngModel)]="item.trip" title="Tick this box to enter trip details otherwise we assume you had no trip for this day" (change)="deleteComplianceTrip(item,$event)"  *ngIf="complianceReturn?.status_ind !== 51 "></td>
            <td><input *ngIf="i!=0 && item.id === 0" class="form-check-input" type="checkbox" [(ngModel)]="item.copyprevious" [disabled]="!item.trip" (change)="copyPrevious(item,$event)"></td>
            <td class="max-200px">
                <select  [(ngModel)]="item.registration_number" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.registration_number" value="" disabled></option>
                    <option *ngFor="let veh of vehicleRes" [value]="veh.id"
                            class="roboto-normal-black-16px">{{veh.VehicleEntry.registration_number}}
                        - {{veh.vehicle_type}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select   [(ngModel)]="item.driver_id" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.driver_id" value="" disabled></option>
                    <option *ngFor="let driver of driverslist"
                            [value]="driver.id">{{driver.first_name}} {{driver.last_name}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select [(ngModel)]="item.place_id_f1" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f1" value="" disabled></option>
                    <option *ngFor="let place of SAPlaces" [value]="place.id">{{place.name}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select   [(ngModel)]="item.place_id_f2" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f2" value="" disabled></option>
                    <option *ngFor="let border of SAborderCrossings" [value]="border.id"
                            class="roboto-normal-black-16px">{{border.name}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select  [(ngModel)]="item.place_id_f3" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f3" value="" disabled></option>
                    <option *ngFor="let border of NonSABorderCrossings"
                            [value]="border.id">{{border.name}}</option>
                </select>

                <!--              <input type="text" [(ngModel)]="selectedPlace" class="max-200px input-gray-border" (input)="filterPlaces($event.target.value)">-->
                <!--              <div class="autocomplete-items">-->
                <!--                  <div *ngFor="let border of filteredNonSABorderCrossings" (click)="selectPlace(border, item)">-->
                <!--                      {{ border.PlaceName }}-->
                <!--                  </div>-->
                <!--              </div>-->
            </td>
            <td>
                <select   [(ngModel)]="item.place_id_f4" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f4" value="" disabled></option>
                    <option *ngFor="let place of DestinationPlaces" [value]="place.id">{{place.name}}</option>
                </select>
            </td>
            <td class="max-80px" *ngIf="isPassenger"><input type="text" [(ngModel)]="item.num_pax"
                                                            class="max-80px input-gray-border"
                                                            [disabled]="!item.trip"></td>
            <td class="max-80px" *ngIf="!isPassenger">
                <select   [(ngModel)]="item.freight_type_id" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.freight_type_id" value="" disabled></option>
                    <option *ngFor="let type of Freighttypes"
                            [value]="type.id">{{type.description}}</option>
                </select>
            </td>

            <td class="max-80px" *ngIf="!isPassenger"><input type="text" [(ngModel)]="item.mass_kg"
                                                             class="max-80px input-gray-border"
                                                             [disabled]="!item.trip"></td>

<!--            <td>{{item?.document?.length}}</td>-->
            <td >{{item?.document_total}}</td>
            <!-- <td *ngIf="isAdmin" data-toggle="modal" data-target="#uploadPassengersList" style="color: #00008b; text-decoration: underline" (click)="setcurrentReturn(item)">{{item?.document_total}}</td> -->
           
            <td>
                     <span 
                             id="btnsave"
                             title="Save Record"
                             class="btn btn-sm pull-center myButton" [disabled]="!item.trip " *ngIf="complianceReturn?.status_ind !== 51"
                             style="margin: 0%">
                    <i class="fa fa-save fa-2x"   aria-hidden="true" (click)="saveReturn(item, i, 'forward')" ></i>
                    </span>
                <span
                        id="btnupload"
                        title="Upload list"
                        class="btn btn-sm pull-center myButton" *ngIf="item.id && item.id !== 0 &&!isNoTrip"
                        style="margin: 0%">
                    <i class="fa fa-upload fa-2x" aria-hidden="true" (click)="setcurrentReturn(item)"
                       data-toggle="modal" data-target="#uploadPassengersList"></i>
                    </span>


                <span
                
                        title="Passenger List"
                        style="margin: 0%"
                        class="btn btn-sm pull-center myButton" *ngIf="item.id && item.id !== 0 && isPassenger"
                >
                   <i class="fa fa-user fa-2x" aria-hidden="true" (click)="gotoPassengerList(item)"
                      data-toggle="modal"></i>
                    </span>

                <span
                
                        title="Add"
                        style="margin: 0%"
                        class="btn btn-sm pull-center myButton" *ngIf="item.id && item.id !== 0 && complianceReturn?.status_ind !== 51 "

                        (click)="addRow(item, i)"
                >
                     <i class="fa fa-plus-square-o fa-2x" aria-hidden="true"></i>
                    </span>
            </td>
        </tr>
        </tbody>
    </table>
    <!-- Pagination controls -->
<!--    <div class="pull-right">-->
<!--        <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1" class="btn" [ngClass]="{'btn-next' : currentPage !== 1, 'btn-return-tab' : currentPage === 1}"> Previous </button>-->
<!--        <span> Page {{ currentPage }} </span>-->
<!--        <button (click)="currentPage = currentPage + 1" [disabled]="getEndIndex() >= monthlyFowardsReturns.length" class="btn" [ngClass]="{'btn-next' : getEndIndex() < monthlyFowardsReturns.length, 'btn-return-tab' : getEndIndex() >= monthlyFowardsReturns.length}"> Next</button>-->
<!--    </div>-->

    <!-- Pagination controls -->
    <div>
        <button (click)="navigateToPage(currentPage - 1)" [disabled]="currentPage === 1" [ngClass]="{'btn-next' : currentPage !== 1, 'btn-return-tab' : currentPage === 1}">Previous</button>
        <ng-container *ngFor="let page of getPageNumbers()">
            <button [disabled]="page === currentPage" (click)="navigateToPage(page)" >
                {{ page }}
            </button>
        </ng-container>
        <button (click)="navigateToPage(currentPage + 1)" [disabled]="getEndIndex() >= monthlyFowardsReturns.length" [ngClass]="{'btn-next' : getEndIndex() < monthlyFowardsReturns.length, 'btn-return-tab' : getEndIndex() >= monthlyFowardsReturns.length}">Next</button>
    </div>
    <!--    <button (click)="addRow()">Add Row</button>-->

</div>
<!--end of table-->

<!--Return Trips Table-->
<!--<div class="mt-lg-5" *ngIf="!isFowards">-->
<div class="mt-lg-5" [ngStyle]="{'display' : !isFowards ? 'block' : 'none'}">
    <table class="table custom_table" cellspacing="0" width="100%">
        <thead>
        <tr>
            <th>Day & Date</th>
            <th class="th-sm">
                Trip?
            </th>
            <th class="th-sm">
                Copy Previous
            </th>
            <th class="th-sm">
                Registration No
            </th>
            <th>
                Driver
            </th>
            <th>
                Depart From
            </th>
            <th>
                Departure Border
            </th>
            <th>
                SA Border
            </th>
            <th>
                Destination
            </th>
            <th *ngIf="isPassenger">
                Number of passengers
            </th>
            <th *ngIf="!isPassenger">
                Freight Category
            </th>
            <th *ngIf="!isPassenger">
                Mass
            </th>
            <th>
                # Docs
            </th>
            <th class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody>
<!--        <tr *ngFor="let item of monthlyReturnsReturns; let i = index">-->
        <tr *ngFor="let item of monthlyReturnsReturns.slice(getReturnStartIndex(), getReturnEndIndex()); let i = index">
            <td><label>{{item.calendar.ddd}}, {{item.calendar.dd}} {{item.calendar.mmm}}  </label></td>
            <td><input class="form-check-input" type="checkbox" [(ngModel)]="item.trip" title="Tick this box to enter trip details otherwise we assume you had no trip for this day" (change)="deleteComplianceTrip(item,$event)" *ngIf="complianceReturn?.status_ind !== 51 "></td>
            <td><input *ngIf="i!=0 && item.id === 0" class="form-check-input" type="checkbox" [(ngModel)]="item.copyprevious" [disabled]="!item.trip" (change)="copyPrevious(item,$event)"></td>
            <td class="max-200px">
                <select  [(ngModel)]="item.registration_number" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="item.registration_number === null || item.registration_number === 'undefined'" value="" disabled></option>
                    <option *ngFor="let veh of vehicleRes" [value]="veh.id"
                            class="roboto-normal-black-16px">{{veh.VehicleEntry.registration_number}}
                        - {{veh.vehicle_type}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select  [(ngModel)]="item.driver_id" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.driver_id" value="" disabled></option>
                    <option *ngFor="let driver of driverslist"
                            [value]="driver.id">{{driver.first_name}} {{driver.last_name}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select   [(ngModel)]="item.place_id_f1" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f1" value="" disabled></option>
                    <option *ngFor="let place of DestinationPlaces" [value]="place.id">{{place.name}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select   [(ngModel)]="item.place_id_f2" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f2" value="" disabled></option>
                    <option *ngFor="let border of NonSABorderCrossings" [value]="border.id"
                            class="roboto-normal-black-16px">{{border.name}}</option>
                </select>
            </td>
            <td class="max-200px">
                <select   [(ngModel)]="item.place_id_f3" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f3" value="" disabled></option>
                    <option *ngFor="let border of SAborderCrossings" [value]="border.id"
                            class="roboto-normal-black-16px">{{border.name}}</option>
                </select>
            </td>
            <td>
                <select  [(ngModel)]="item.place_id_f4" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.place_id_f4" value="" disabled></option>
                    <option *ngFor="let place of SAPlaces" [value]="place.id">{{place.name}}</option>
                </select>
            </td>
            <td class="max-80px" *ngIf="isPassenger"><input type="text" [(ngModel)]="item.num_pax"
                                                            class="max-80px input-gray-border"
                                                            [disabled]="!item.trip"></td>
            <td class="max-80px" *ngIf="!isPassenger">
                <select   [(ngModel)]="item.freight_type_id" class="max-200px input-gray-border" [disabled]="!item.trip">
                    <option *ngIf="!item.freight_type_id" value="" disabled></option>
                    <option *ngFor="let type of Freighttypes"
                            [value]="type.id">{{type.description}}</option>
                </select>
            </td>

            <td class="max-80px" *ngIf="!isPassenger"><input type="text" [(ngModel)]="item.mass_kg"
                                                             class="max-80px input-gray-border"
                                                             [disabled]="!item.trip"></td>

<!--            <td>{{item?.document?.length}}</td>-->
<td >{{item?.document_total}}</td>
<td  data-toggle="modal" data-target="#uploadPassengersList" style="color: #00008b; text-decoration: underline" (click)="setcurrentReturn(item)">{{item?.document_total}}</td>
            <td>
                     <span     
                             id="save"
                             title="Save Record"
                             class="btn btn-sm pull-center myButton" [disabled]="!item.trip" *ngIf="complianceReturn?.status_ind !== 51 "
                             style="margin: 0%">
                    <i class="fa fa-save fa-2x"  aria-hidden="true" (click)="saveReturn(item, i, 'return')" ></i>
                    </span>
                <span
                       
                id="upload"
                        title="Upload list"
                        class="btn btn-sm pull-center myButton" *ngIf="item.id && item.id !== 0 "
                        style="margin: 0%">
                    <i class="fa fa-upload fa-2x" aria-hidden="true" (click)="setcurrentReturn(item)"
                       data-toggle="modal" data-target="#uploadPassengersList"></i>
                    </span>


                <span

                        title="Passenger List"
                        style="margin: 0%"
                        class="btn btn-sm pull-center myButton" *ngIf="item.id && item.id !== 0 && isPassenger"
                >
                   <i class="fa fa-user fa-2x" aria-hidden="true" (click)="gotoPassengerList(item)"
                      data-toggle="modal"></i>
                    </span>

                <span

                        title="Add"
                        style="margin: 0%"
                        class="btn btn-sm pull-center myButton" *ngIf="item.id && item.id !== 0  && complianceReturn?.status_ind !== 51"

                        (click)="addRow(item, i)"
                >
                     <i class="fa fa-plus-square-o fa-2x" aria-hidden="true"></i>
                    </span>
            </td>
        </tr>
        </tbody>
    </table>
<!--    &lt;!&ndash; Pagination controls &ndash;&gt;-->
<!--    <div class="pull-right">-->
<!--        <button (click)="returnCurrentPage = returnCurrentPage - 1" [disabled]="returnCurrentPage === 1" class="btn" [ngClass]="{'btn-next' : returnCurrentPage !== 1, 'btn-return-tab' : returnCurrentPage === 1}"> Previous </button>-->
<!--        <span> Page {{ returnCurrentPage }} </span>-->
<!--        <button (click)="returnCurrentPage = returnCurrentPage + 1" [disabled]="getEndIndex() >= monthlyReturnsReturns.length" class="btn" [ngClass]="{'btn-next' : getEndIndex() < monthlyReturnsReturns.length, 'btn-return-tab' : getEndIndex() >= monthlyReturnsReturns.length}"> Next</button>-->
<!--    </div>-->
    <!--    <button (click)="addRow()">Add Row</button>-->

    <!-- Pagination controls -->
    <div>
        <button (click)="returnNavigateToPage(returnCurrentPage - 1)" [disabled]="returnCurrentPage === 1" [ngClass]="{'btn-next' : returnCurrentPage !== 1, 'btn-return-tab' : returnCurrentPage === 1}">Previous</button>
        <ng-container *ngFor="let page of getReturnPageNumbers()">
            <button [disabled]="page === returnCurrentPage" (click)="returnNavigateToPage(page)">
                {{ page }}
            </button>
        </ng-container>
        <button (click)="navigateToPage(returnCurrentPage + 1)" [disabled]="getReturnEndIndex() >= monthlyReturnsReturns.length" [ngClass]="{'btn-next' : getEndIndex() < monthlyReturnsReturns.length, 'btn-return-tab' : getEndIndex() >= monthlyReturnsReturns.length}">Next</button>
    </div>

</div>
<!--end of table-->

<!-- Buttons Options section-->
<div class="row">
    <div class="col no-mp" style="text-align: center">
        <button
                class="btn hd-btn-close"
                [routerLink]="['/monthly-compliance/list', carrierId]"
                title="Back to Permit List"

        >
            Back to Permit List
        </button>
        <button *ngIf="complianceReturn?.status_ind !== 51"
                class="btn hd-btn"
               (click)="completeComplianceReturn()"
        >
            Month Submission Complete
        </button>
    </div>
</div>
<!--End of Button Options section-->


<!--Document Uploads Section-->

<!--View Document-->
<div
        class="modal fade"
        id="ocausDocument"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
        style="z-index:9999"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Document Upload</h5>
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-lg">
                <div style="width: 99%; min-height: 470px">
                    <pdf-viewer
                            *ngIf="pdfSrc"
                            [src]="pdfSrc"
                            [render-text]="true"
                            style="display: block"
                            [original-size]="false"
                            [autoresize]="true"
                    ></pdf-viewer>
                    <ngx-loading [show]="isLoading"></ngx-loading>
                </div>

                <div style="width: 99%; min-height: 470px" class="text-center"></div>
            </div>
            <div class="modal-footer">
                <button
                        class="btn btn-next"
                        type="button"
                        class="close"
                        data-dismiss="modal"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
<!--End of View Document-->

<!--Upload Document-->
<div
        class="modal fade"
        id="uploadPassengersList"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{docHeaders}}</h5>
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-lg">
                <div *ngIf="complianceReturn?.status_ind !== 51">
                <div class="dropzone" fileDragDrop>
                    <div class="file_upload_wrapper">
                        <img src="/assets/upload_icon.png" alt="Upload icon"/>
                        <input
                                type="file"
                                id="upload_file"
                                class="file_upload_input"
                                title=""
                                (change)="pushFileIntoReturn($event)"
                        />
                        <label for="upload_file">
                            Drag and drop files here or click to search on your computer
                        </label>
                        <span class="upload_file_text">Upload file</span>
                    </div>
                </div>
                <span class="max_limit">Max file size 5MB PDF format.</span>
                </div>
                <div>
                    <table class="table borderless" width="100%">
                        <tbody>
                        <tr>
                            <th><b>File Name</b></th>
                            <th><b>Document Type</b></th>
                            <th>Action</th>
                        </tr>

                        <ng-container *ngIf="selectedreturnrow?.document">
                            <tr class="text-primary" *ngFor="let doc of selectedreturnrow.document">
                                <td> {{doc.file_name}}</td>
                                <td> PDF</td>
                                <td>
                                    <button *ngIf="doc.document_link"
                                            type="button"
                                            class="btn_icon"
                                            data-toggle="modal"
                                            data-target="#ocausDocument"
                                            aria-label="View file"
                                            style="border: none"
                                            (click)="viewDoc(doc)"
                                    >
                                        <img
                                                src="assets/visibility.png"
                                                style="height: 14px"
                                                alt=""
                                        />
                                    </button>
                                    <button *ngIf="doc.document_link"
                                            (click)="removeUploadedFile(doc)"
                                            type="button"
                                            class="btn_icon"
                                            style="border: none; height: 14px"
                                            aria-label="Delete file"
                                    >
                                        <img
                                                style="height: 14px"
                                                src="assets/delete.png"
                                                alt=""
                                        />
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
                <!--End o

                                <div style="width: 99%; min-height: 470px" class="text-center"></div>
                            </div>
                            <div class="modal-footer">
                                <button
                                        class="btn btn_primary"
                                        type="button"
                                        class="close"
                                        data-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                f Upload Document-->
                <!--End of Document Uploads section-->
            </div>
            <div class="modal-footer">
                <button class="btn btn-next button" type="button" (click)="saveDocument()" *ngIf="complianceReturn?.status_ind !== 51">
                    Save Documents
                </button>
                <button
                        class="btn btn_primary"
                        type="button"
                        class="close"
                        data-dismiss="modal"></button>
            </div>
        </div>
    </div>
</div>
<!--End of Upload Document-->

<!--Add Driver Modal-->
<ng-template #add let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Driver</h4>
        <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="modal.dismiss('Cross click')"
        >
            &times;
        </button>
    </div>
    <div class="modal-body">
        <app-carrier-driver-add
                [carrierId]="carrierId"
                (saved)="modal.dismiss('Cross click')"
        ></app-carrier-driver-add>
    </div>
</ng-template>
<!--End of Add Driver modal-->


<!--No trip Modal-->

<button id="btnshowNoTrip"
        type="button"
        class="btn_icon"
        data-toggle="modal" data-target="#noTripPopup"
        aria-label="View file"
        style="display: none;"
>
    Show No trip modal
</button>
<div
        class="modal fade"
        id="noTripPopup"
        tabindex="-1"
        role="dialog"
        aria-labelledby="noTripPopupTitle"
        aria-hidden="true"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="noTripPopupTitle">No trips to Report For Month</h5>
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-lg">
                <div style="width: 99%;">
                    <div class="form-group">
                        <label for="noTripInput">Justify your null return</label>
                        <textarea [(ngModel)]="noTripDesc" class="form-control" id="noTripInput" rows="10" maxlength="500" (input)="remainChar()"></textarea>
                        <small>{{ remainingCharacters }} characters remaining</small>
                    </div>
                </div>


            </div>
            <div class="modal-footer">
                <button class="btn btn-next button" type="button" (click)="saveJustification()">
                    Save Justification
                </button>
                <!-- <button
                        class="btn btn-return-tab button"
                        type="button"
                        data-dismiss="modal"><span style="color: black">Cancel</span></button> -->
                        <button class="btn btn-return-tab button" type="button" data-dismiss="modal" (click)="cancelModal()">
                            <span style="color: black">Cancel</span>
                        </button>
                        
            </div>
        </div>
    </div>
</div>
<!--End of View Document-->
